import { useCallback, useMemo } from "react";

import { ListInfo, useListInfo } from "./ListInfoProvider";

export type ListHeadInfo = {
	allSelected: boolean;
	someSelected: boolean;

	selectAll: (selected: boolean) => void;
};

export default function useListHeadInfo(): ListHeadInfo {
	const listInfo: ListInfo = useListInfo();

	const selectableElements = useMemo(() => {
		return Object.entries(listInfo.elements).filter(
			element => element[1].enabled && element[1].visible
		);
	}, [listInfo.elements]);

	const selectedElements = useMemo(
		() => selectableElements.filter(element => element[1].selected),
		[selectableElements]
	);

	const selectAll = useCallback(
		(selected: boolean) => {
			listInfo.setSelected(
				selectableElements.map(element => element[0]),
				selected
			);
		},
		[selectableElements, listInfo.setSelected]
	);

	return useMemo(
		() => ({
			allSelected:
				selectedElements.length > 0 &&
				selectedElements.length === selectableElements.length,
			someSelected:
				selectedElements.length > 0 &&
				selectedElements.length < selectableElements.length,
			selectAll
		}),
		[selectedElements, selectableElements, selectAll]
	);
}
